<!-- Used only in composition in each discount pass validation -->
<template>
  <div>
    <!-- Put h2 header in info slot -->
    <slot name="summary" />
    <br>
    <form
      class="form"
      @submit.prevent="handleSubmit"
    >
      <transition name="slide-down">
        <p
          v-if="errorMessage && showFormLevelErrorMessage"
          class="form__error"
          role="alert"
          v-html="errorMessage"
        />
      </transition>
      <slot name="eligibility-fields" />
      <div class="navigation-buttons">
        <div
          class="input-container input-container--button"
          :class="{ 'input-container--loading': loading }"
        >
          <input
            type="submit"
            class="button button--submit"
            :disabled="loading || disableSubmit"
            value="Continue"
          >
        </div>
        <PreviousStepButton
          v-if="$listeners.back"
          @click="$emit('back')"
        />
        <!-- Alternate back button is necessary if the verification type is used standalone, without a parent component to select verification type. -->
        <PreviousStepButton v-else />
      </div>
    </form>
    <slot name="details" />
  </div>
</template>
<script>
import PreviousStepButton from '@/components/PreviousStepButton.vue';

/**
 * ERROR HANDLING
 *
 * ** Backend validation only with one field:
 * Pass error message back up to validation type; validation type handles its own default error message and shows inline. Submit disabled if there is no input. Don't show form validation level error message.
 * Incl: indego access pass, cali EBT, metro tap, nevada EBT
 *
 * ** Backend validation with multiple fields:
 * Display error at form level.
 * Incl: passcode verification
 *
 * ** Front end validation with any number of fields:
 * Submit disabled until correct. Display inline errors for text fields. Do not display errors on checkboxes. Display any submit errors at form level since they will not be field specific.
 * Incl: disability verification, senior self cert, student cerification
 *
 * ** Multiple fields with a mix of front and back end validation:
 * Display front end validation and do inline error handling where possible. Display submit error message at form level and do not style form fields, as it is not possible to know which fields had errors.
 * Incl: Reduced Fare RTC,
 */

export default {
  components: { PreviousStepButton },
  props: {
    validationParams: { type: Object, required: true },
    afterSuccess: { type: Function, default: () => {} },
    disableSubmit: { type: Boolean, default: false },
    handleSubmitError: { type: Function, default: () => {} },
    showFormLevelErrorMessage: { type: Boolean, default: true },
    defaultErrorMessage: { type: String, default: undefined }, // Only used for reduced fare RTC
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
    };
  },
  methods: {
    async handleSubmit() {
      this.loading = true;
      this.errorMessage = null;

      const response = await this.$store.dispatch('validateDiscount', this.validationParams);
      this.loading = false;

      if (response.is_valid) {
        this.afterSuccess();
        this.$router.push({ name: this.$store.getters.nextStep(this.$route.name) });
      } else {
        this.handleSubmitError(response.message);
        if (this.showFormLevelErrorMessage) {
          this.errorMessage = response.message || this.defaultErrorMessage || 'Unable to validate eligibility. Please try again or contact customer service.';
        }
      }
    },
  },
};
</script>
